/* Maison Brogi — global theme runtime (vanilla replacement for the original React app shell). */
(function () {
  'use strict';

  var B = (window.Brogi = window.Brogi || {});
  B.routes = B.routes || {};
  var strings = B.strings || {};
  var root = (B.routes.root || '/').replace(/\/$/, '');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function store(key, val) {
    try {
      if (arguments.length === 1) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  B.$ = $; B.$$ = $$;

  /* ------------------------------------------------------------------ Money */
  B.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || B.moneyFormat || '€{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmtNum(n, dec, t, d) {
      t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(dec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      default: v = fmtNum(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  };

  /* ------------------------------------------------------------------ Toasts */
  var ICONS = {
    success: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/></svg>',
    error: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg>'
  };
  // Sonner look-alike. Default position = bottom-right (sonner default, as in the original <Toaster />);
  // pass { position: 'top-center' } where the original did. Optional { description } = second line.
  window.BrogiToast = {
    show: function (message, opts) {
      opts = opts || {};
      var host = document.getElementById('brogi-toaster');
      if (!host) return;
      var pos = opts.position || 'bottom-right';
      host.classList.toggle('pos-top-center', pos === 'top-center');
      host.classList.toggle('pos-bottom-right', pos !== 'top-center');
      var el = document.createElement('div');
      el.className = 'brogi-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="brogi-toast-icon">' + (ICONS[opts.type || 'success'] || '') + '</span><div class="brogi-toast-content"><div class="brogi-toast-title"></div></div>';
      el.querySelector('.brogi-toast-title').textContent = message;
      if (opts.description) {
        var d = document.createElement('div');
        d.className = 'brogi-toast-desc';
        d.textContent = opts.description;
        el.querySelector('.brogi-toast-content').appendChild(d);
      }
      if (pos === 'top-center') host.appendChild(el); else host.insertBefore(el, host.firstChild);
      setTimeout(function () {
        el.classList.add('is-leaving');
        setTimeout(function () { el.remove(); }, 400);
      }, opts.duration || 4000);
    }
  };

  /* ------------------------------------------------------------------ Scroll lock */
  var locks = 0;
  B.lockScroll = function () { locks++; document.documentElement.style.overflow = 'hidden'; };
  B.unlockScroll = function () { locks = Math.max(0, locks - 1); if (!locks) document.documentElement.style.overflow = ''; };

  /* ------------------------------------------------------------------ Reveal */
  var revealIO = null;
  function initReveal(ctx) {
    var els = $$('[data-reveal]:not([data-reveal-ready])', ctx);
    if (!els.length) return;
    els.forEach(function (el) {
      el.setAttribute('data-reveal-ready', '');
      var d = el.dataset;
      if (d.revealY != null) el.style.setProperty('--reveal-y', d.revealY + 'px');
      if (d.revealX != null) { el.style.setProperty('--reveal-x', d.revealX + 'px'); if (d.revealY == null) el.style.setProperty('--reveal-y', '0px'); }
      if (d.revealScale != null) { el.style.setProperty('--reveal-scale', d.revealScale); if (d.revealY == null) el.style.setProperty('--reveal-y', '0px'); }
      if (d.revealOpacity != null) el.style.setProperty('--reveal-opacity', d.revealOpacity);
      if (d.revealDuration) el.style.setProperty('--reveal-duration', d.revealDuration + 's');
      if (d.revealDelay) el.style.setProperty('--reveal-delay', d.revealDelay + 's');
    });
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-revealed'); }); return; }
    els.forEach(function (el) {
      if (el.hasAttribute('data-reveal-immediate')) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-revealed'); }); });
        return;
      }
      var margin = el.dataset.revealMargin;
      var io = margin ? new IntersectionObserver(cb, { rootMargin: '0px 0px ' + margin + ' 0px' }) : (revealIO = revealIO || new IntersectionObserver(cb, { rootMargin: '0px 0px -40px 0px' }));
      io.observe(el);
    });
    function cb(entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); obs.unobserve(e.target); }
      });
    }
  }
  B.initReveal = initReveal;

  /* ------------------------------------------------------------------ Header */
  function initHeader() {
    var nav = document.getElementById('brogi-nav');
    if (!nav) return;
    var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 40); };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    var menu = document.getElementById('brogi-menu');
    var overlay = $('[data-menu-overlay]');
    var btn = $('[data-menu-open]', nav);
    function setMenu(open) {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (overlay) overlay.hidden = !open;
      nav.setAttribute('data-menu-state', open ? 'open' : 'closed');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      open ? B.lockScroll() : B.unlockScroll();
    }
    on(btn, 'click', function () { setMenu(!menu.classList.contains('is-open')); });
    $$('[data-menu-close]').forEach(function (b) { on(b, 'click', function () { setMenu(false); }); });
    on(overlay, 'click', function () { setMenu(false); });
    if (menu) $$('a', menu).forEach(function (a) { on(a, 'click', function () { if (menu.classList.contains('is-open')) setMenu(false); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false); });

    // Country dropdown
    $$('[data-country-dropdown]').forEach(function (dd) {
      var t = $('[data-country-toggle]', dd), m = $('[data-country-menu]', dd);
      on(t, 'click', function (e) { e.stopPropagation(); var open = m.hidden; m.hidden = !open; t.setAttribute('aria-expanded', open); });
      on(document, 'mousedown', function (e) { if (!dd.contains(e.target)) { m.hidden = true; t.setAttribute('aria-expanded', 'false'); } });
    });
  }

  /* ------------------------------------------------------------------ Accordions (generic) */
  function initAccordions(ctx) {
    $$('[data-accordion]:not([data-acc-ready])', ctx).forEach(function (acc) {
      acc.setAttribute('data-acc-ready', '');
      var toggle = $('[data-accordion-toggle]', acc);
      on(toggle, 'click', function () {
        var open = !acc.classList.contains('is-open');
        var group = acc.closest('[data-accordion-group]');
        if (open && group && group.hasAttribute('data-single')) {
          $$('[data-accordion].is-open', group).forEach(function (o) {
            if (o !== acc) { o.classList.remove('is-open'); var tt = $('[data-accordion-toggle]', o); tt && tt.setAttribute('aria-expanded', 'false'); }
          });
        }
        acc.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (acc.hasAttribute('data-open')) { acc.classList.add('is-open'); toggle && toggle.setAttribute('aria-expanded', 'true'); }
    });
  }
  B.initAccordions = initAccordions;

  /* ------------------------------------------------------------------ Announcement bar */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var slides = $$('[data-announcement-slide]', bar);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; if (k === i) { s.classList.remove('brogi-fade-in'); void s.offsetWidth; s.classList.add('brogi-fade-in'); } });
    }
    var auto = parseInt(bar.dataset.autoplay || '0', 10);
    function restart() { if (timer) clearInterval(timer); if (auto > 0) timer = setInterval(function () { show(i + 1); }, auto * 1000); }
    on($('[data-announcement-prev]', bar), 'click', function () { show(i - 1); restart(); });
    on($('[data-announcement-next]', bar), 'click', function () { show(i + 1); restart(); });
    restart();
  }

  /* ------------------------------------------------------------------ Search */
  function initSearch() {
    var wrap = $('[data-search]');
    if (!wrap) return;
    var input = $('[data-search-input]', wrap), results = $('[data-search-results]', wrap), t = null, ctrl = null;
    function open() { wrap.hidden = false; B.lockScroll(); setTimeout(function () { input && input.focus(); }, 50); }
    function close() { if (wrap.hidden) return; wrap.hidden = true; B.unlockScroll(); }
    $$('[data-search-open]').forEach(function (b) {
      on(b, 'click', function () {
        var menu = document.getElementById('brogi-menu');
        if (menu && menu.classList.contains('is-open')) { var c = $('[data-menu-close]'); c && c.click(); }
        open();
      });
    });
    $$('[data-search-close]', wrap).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    on(input, 'input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (B.routes.predictive_search || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('[data-predictive-results]');
            results.innerHTML = sec ? sec.innerHTML : '';
            initReveal(results); initWishlistButtons(results);
          }).catch(function () {});
      }, 250);
    });
  }

  /* ------------------------------------------------------------------ Wishlist */
  var WL_KEY = 'maison-brogi-wishlist';
  function wlRead() {
    var raw = store(WL_KEY);
    // Original stored either an array of handles or a zustand-persist object {state:{items:[...]}}
    if (Array.isArray(raw)) return raw.map(function (x) { return typeof x === 'string' ? x : x && x.handle; }).filter(Boolean);
    if (raw && raw.state && Array.isArray(raw.state.items)) return raw.state.items.map(function (x) { return typeof x === 'string' ? x : x && (x.handle || (x.node && x.node.handle)); }).filter(Boolean);
    return [];
  }
  function wlWrite(items) { store(WL_KEY, items); document.dispatchEvent(new CustomEvent('brogi:wishlist-change', { detail: { items: items } })); }
  window.BrogiWishlist = {
    items: wlRead,
    has: function (h) { return wlRead().indexOf(h) > -1; },
    toggle: function (h, title) {
      var items = wlRead(), idx = items.indexOf(h), added = idx === -1;
      added ? items.push(h) : items.splice(idx, 1);
      wlWrite(items);
      BrogiToast.show(added ? (strings.addedToWishlist || 'Added to wishlist') : (strings.removedFromWishlist || 'Removed from wishlist'), { position: 'top-center' });
      return added;
    },
    remove: function (h) { var items = wlRead().filter(function (x) { return x !== h; }); wlWrite(items); }
  };
  function paintWishlist() {
    var items = wlRead();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var active = items.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      $$('.brogi-heart', b).forEach(function (svg) {
        svg.classList.toggle('fill-faded-rose', active);
        svg.classList.toggle('text-faded-rose', active);
        svg.classList.toggle('text-foreground', !active);
      });
      $$('[data-wishlist-label]', b).forEach(function (l) { l.textContent = active ? (l.dataset.on || 'Saved') : (l.dataset.off || 'Save'); });
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = items.length; c.hidden = items.length === 0; });
  }
  function initWishlistButtons() { paintWishlist(); }
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    BrogiWishlist.toggle(b.getAttribute('data-wishlist-toggle'));
  });
  on(document, 'brogi:wishlist-change', paintWishlist);
  on(window, 'storage', function (e) { if (e.key === WL_KEY) paintWishlist(); });

  /* ------------------------------------------------------------------ Recently viewed */
  var RV_KEY = 'maison-brogi-recently-viewed';
  B.recentlyViewed = {
    items: function () {
      var raw = store(RV_KEY);
      if (Array.isArray(raw)) return raw.map(function (x) { return typeof x === 'string' ? x : x && x.handle; }).filter(Boolean);
      var list = raw && raw.state && (raw.state.handles || raw.state.items);
      if (Array.isArray(list)) return list.map(function (x) { return typeof x === 'string' ? x : x && x.handle; }).filter(Boolean);
      return [];
    },
    add: function (h) {
      var items = this.items().filter(function (x) { return x !== h; });
      items.unshift(h);
      // Same storage shape as the original site (zustand persist)
      store(RV_KEY, { state: { handles: items.slice(0, 12) }, version: 0 });
    }
  };

  /* ------------------------------------------------------------------ Product cards (client-side) */
  B.fetchProductCards = function (handles) {
    return Promise.all((handles || []).map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { return t.trim(); })
        .catch(function () { return ''; });
    }));
  };

  /* ------------------------------------------------------------------ Cart */
  function jsonFetch(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Cart error'); err.data = j; throw err; }
        return j;
      });
    });
  }

  var drawer = null;
  function sectionUrl() { return (B.routes.cart_add || '/cart/add').replace(/add$/, ''); }
  function renderDrawer(html) {
    if (!drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var cur = $('[data-cart-inner]', drawer);
    if (fresh && cur) cur.replaceWith(fresh);
    initCartUpsell();
    initCartNote();
    if (window.Brogi && B.init) B.init(drawer);
  }
  function refreshDrawer() {
    return fetch(root + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j['cart-drawer']) renderDrawer(j['cart-drawer']); })
      .catch(function () {});
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = !count; });
  }
  function afterChange(cart, sections) {
    if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
    if (sections && sections['cart-drawer']) renderDrawer(sections['cart-drawer']);
    else refreshDrawer();
    document.dispatchEvent(new CustomEvent('brogi:cart-change', { detail: { cart: cart } }));
  }
  function busy(v) { if (drawer) drawer.setAttribute('aria-busy', v ? 'true' : 'false'); }

  var cartIsPage = B.cartType === 'page';
  window.BrogiCart = {
    open: function () {
      if (cartIsPage || !drawer) { window.location.href = B.routes.cart || '/cart'; return; }
      if (drawer.classList.contains('is-open')) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      var ov = $('[data-cart-overlay]'); if (ov) ov.hidden = false;
      B.lockScroll();
      refreshDrawer().then(function () { initCartUpsell(); initCartNote(); });
      setTimeout(function () { var c = $('[data-cart-close]', drawer); c && c.focus({ preventScroll: true }); }, 60);
    },
    close: function () {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      var ov = $('[data-cart-overlay]'); if (ov) ov.hidden = true;
      B.unlockScroll();
    },
    refresh: function () { return jsonFetch(root + '/cart.js').then(function (c) { afterChange(c); return c; }); },
    get: function () { return jsonFetch(root + '/cart.js'); },
    addMany: function (items, opts) {
      opts = opts || {};
      busy(true);
      return jsonFetch(B.routes.cart_add + '.js', { items: items, sections: 'cart-drawer' })
        .then(function (res) {
          return jsonFetch(root + '/cart.js').then(function (cart) {
            afterChange(cart, res.sections);
            if (opts.title) {
              var addedMsg = strings.addedToBag || 'Added to bag';
              if (addedMsg.indexOf('[title]') > -1) BrogiToast.show(addedMsg.replace('[title]', opts.title), { position: 'top-center' });
              else BrogiToast.show(addedMsg, { description: opts.title, position: 'top-center' });
            }
            if (opts.openDrawer !== false) BrogiCart.open();
            trackAdd(items, cart);
            return res;
          });
        })
        .catch(function (err) {
          BrogiToast.show((err && err.message) || strings.error || 'Something went wrong. Please try again.', { type: 'error' });
          throw err;
        })
        .finally(function () { busy(false); });
    },
    add: function (variantId, quantity, opts) {
      opts = opts || {};
      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (opts.properties) item.properties = opts.properties;
      if (opts.selling_plan) item.selling_plan = opts.selling_plan;
      return BrogiCart.addMany([item], opts).then(function (res) { return res.items ? res.items[0] : res; });
    },
    change: function (key, quantity) {
      busy(true);
      return jsonFetch(B.routes.cart_change + '.js', { id: key, quantity: quantity, sections: 'cart-drawer' })
        .then(function (cart) { afterChange(cart, cart.sections); return cart; })
        .catch(function (err) { BrogiToast.show((err && err.message) || strings.error, { type: 'error' }); })
        .finally(function () { busy(false); });
    }
  };

  function trackAdd(items, cart) {
    try {
      if (window.fbq && B.consent && B.consent()) {
        window.fbq('track', 'AddToCart', { content_ids: items.map(function (i) { return String(i.id); }), content_type: 'product', currency: cart.currency });
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ Cart upsell (complementary products) */
  function initCartUpsell() {
    var box = drawer && drawer.querySelector('[data-cart-upsell]');
    if (!box || box.getAttribute('data-recommend') !== '1') return;
    var pid = box.getAttribute('data-product-id');
    var list = box.querySelector('[data-upsell-list]');
    if (!pid || !list || box.hasAttribute('data-upsell-done')) return;
    box.setAttribute('data-upsell-done', '');
    var limit = box.getAttribute('data-limit') || 4;
    var url = (B.routes.product_recommendations || '/recommendations/products') +
      '?section_id=cart-upsell&limit=' + limit + '&product_id=' + encodeURIComponent(pid) + '&intent=';
    fetch(url + 'complementary')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { return html && html.indexOf('data-add-to-cart') > -1 ? html : fetch(url + 'related').then(function (r) { return r.ok ? r.text() : ''; }); })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-upsell-results]');
        if (!res || !res.children.length) return;   // keep the hand-picked fallback
        var inCart = (box.getAttribute('data-in-cart') || '').split(',');
        list.innerHTML = res.innerHTML;
        B.init(list);
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------ Cart note */
  function initCartNote() {
    var box = drawer && drawer.querySelector('[data-cart-note]');
    if (!box || box.hasAttribute('data-note-ready')) return;
    box.setAttribute('data-note-ready', '');
    var t = null;
    box.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        fetch(root + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: box.value })
        }).catch(function () {});
      }, 600);
    });
  }

  function initCart() {
    drawer = document.getElementById('brogi-cart');
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && !cartIsPage && drawer) { e.preventDefault(); BrogiCart.open(); return; }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { BrogiCart.close(); return; }

      var add = e.target.closest('[data-add-to-cart]');
      if (add) {
        e.preventDefault(); e.stopPropagation();
        if (add.disabled || add.getAttribute('aria-disabled') === 'true') return;
        var id = add.getAttribute('data-add-to-cart');
        if (!id) return;
        add.setAttribute('aria-busy', 'true');
        BrogiCart.add(id, parseInt(add.getAttribute('data-quantity') || '1', 10), { title: add.getAttribute('data-product-title') || '' })
          .catch(function () {})
          .finally(function () { add.removeAttribute('aria-busy'); });
        return;
      }

      var qty = e.target.closest('[data-cart-qty]');
      if (qty) {
        e.preventDefault();
        BrogiCart.change(qty.getAttribute('data-key'), parseInt(qty.getAttribute('data-cart-qty'), 10));
        return;
      }
      var chk = e.target.closest('[data-cart-checkout]');
      if (chk) {
        try {
          if (window.fbq && B.consent && B.consent()) window.fbq('track', 'InitiateCheckout');
        } catch (err) {}
      }
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') BrogiCart.close(); });

    // Product forms (<form data-product-form>) → ajax add
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form || cartIsPage) return;
      e.preventDefault();
      var fd = new FormData(form);
      var id = fd.get('id');
      if (!id) return;
      var props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      BrogiCart.add(id, parseInt(fd.get('quantity') || '1', 10), {
        properties: Object.keys(props).length ? props : undefined,
        selling_plan: fd.get('selling_plan') || undefined,
        title: form.getAttribute('data-product-title') || ''
      }).catch(function () {}).finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  /* ------------------------------------------------------------------ Newsletter (Shopify customer w/ marketing consent) */
  B.subscribe = function (email, opts) {
    opts = opts || {};
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', opts.tags || 'newsletter');
    if (opts.firstName) body.append('contact[first_name]', opts.firstName);
    return fetch(root + '/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function (r) {
      if (!r.ok) return { success: false };
      // Shopify redirects to /challenge when bot protection kicks in
      if (r.url && r.url.indexOf('/challenge') > -1) { window.location.href = r.url; return { success: false, challenge: true }; }
      return r.text().then(function (html) {
        var errors = /class="[^"]*form__message[^"]*errors|id="ContactForm-error"|posted_successfully=false/.test(html);
        return { success: !errors || /already/i.test(html) };
      });
    }).catch(function () { return { success: false }; });
  };

  function initNewsletterForms(ctx) {
    $$('form[data-newsletter-form]:not([data-nl-ready])', ctx).forEach(function (form) {
      form.setAttribute('data-nl-ready', '');
      on(form, 'submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = (input && input.value || '').trim();
        if (!email && form.hasAttribute('data-empty-silent')) return;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          BrogiToast.show(form.dataset.invalid || 'Please enter a valid email address.', { type: 'error' });
          return;
        }
        var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
        B.subscribe(email, { tags: form.dataset.tags || 'newsletter' }).then(function (res) {
          if (res.challenge) return;
          if (res.success) {
            if (input) input.value = '';
            BrogiToast.show(form.dataset.success || "You're in! Welcome to the Brogi family.");
            form.dispatchEvent(new CustomEvent('brogi:subscribed', { bubbles: true }));
          } else {
            BrogiToast.show(strings.error || 'Something went wrong. Please try again.', { type: 'error' });
          }
        }).finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }
  B.initNewsletterForms = initNewsletterForms;

  /* ------------------------------------------------------------------ Consent (cookie banner) */
  var CONSENT_KEY = 'cookie-consent';
  B.consent = function () { try { return localStorage.getItem(CONSENT_KEY) === 'accepted'; } catch (e) { return false; } };
  // prefs: true/false (all/none) or { analytics, marketing, preferences }
  B.consentPrefs = function () {
    try { var p = JSON.parse(localStorage.getItem('cookie-consent-prefs') || 'null'); if (p) return p; } catch (e) {}
    var all = B.consent();
    return { analytics: all, marketing: all, preferences: all };
  };
  B.setConsent = function (prefs) {
    if (typeof prefs === 'boolean') prefs = { analytics: prefs, marketing: prefs, preferences: prefs };
    var all = !!(prefs.analytics && prefs.marketing);
    try {
      localStorage.setItem(CONSENT_KEY, all ? 'accepted' : 'declined');
      localStorage.setItem('cookie-consent-prefs', JSON.stringify(prefs));
    } catch (e) {}
    // Pass the choice on to Shopify's Customer Privacy API so Shopify pixels / apps respect it too.
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent({ analytics: !!prefs.analytics, marketing: !!prefs.marketing, preferences: !!prefs.preferences, sale_of_data: !!prefs.marketing }, function () {});
      }
    } catch (e) {}
    window.dispatchEvent(new Event('brogi-consent-change'));
  };

  /* ------------------------------------------------------------------ Misc helpers */
  // Generic tabs: [data-tabs] > [data-tab="x"] buttons + [data-tab-panel="x"]
  function initTabs(ctx) {
    $$('[data-tabs]:not([data-tabs-ready])', ctx).forEach(function (wrap) {
      wrap.setAttribute('data-tabs-ready', '');
      var tabs = $$('[data-tab]', wrap);
      tabs.forEach(function (t) {
        on(t, 'click', function () {
          var key = t.getAttribute('data-tab');
          tabs.forEach(function (x) { var a = x === t; x.setAttribute('aria-selected', a); x.classList.toggle('is-active', a); });
          $$('[data-tab-panel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
          wrap.dispatchEvent(new CustomEvent('brogi:tab', { detail: { tab: key } }));
        });
      });
    });
  }
  B.initTabs = initTabs;

  // Copy-to-clipboard: <button data-copy="TEXT">
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var text = b.getAttribute('data-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(function () {
      b.classList.add('is-copied');
      setTimeout(function () { b.classList.remove('is-copied'); }, 2000);
    }).catch(function () {});
  });

  B.init = function (ctx) {
    initReveal(ctx); initAccordions(ctx); initTabs(ctx); initNewsletterForms(ctx); paintWishlist();
  };

  function boot() {
    initHeader(); initAnnouncement(); initSearch(); initCart();
    B.init(document);
    document.dispatchEvent(new CustomEvent('brogi:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-init sections when they're re-rendered
  on(document, 'shopify:section:load', function (e) { B.init(e.target); });
  on(document, 'shopify:block:select', function (e) { var el = e.target; if (el && el.scrollIntoView) el.classList && el.classList.add('is-revealed'); });
})();
